import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import './plugins/fontawesome';
import './plugins/axios';
import { i18n } from './plugins/i18n';
import './registerServiceWorker';
import './components';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { StatusBar, Style as StatusBarStyle } from '@capacitor/status-bar';
import { Storage } from '@capacitor/storage';
import PortalVue from 'portal-vue';

if (process.env.VUE_ENABLE_SENTRY === 'YES') {
  Sentry.init({
    dsn: "https://a197c2380e154801b13e01c1cdf62a55@o351778.ingest.sentry.io/5399905",
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  });
}

Device.getInfo().then(async function (info) {
  global.isWeb = info.platform === 'web';
  Vue.config.productionTip = false;
  if (Capacitor.getPlatform() === 'ios') {
    StatusBar.setStyle({
      style: StatusBarStyle.Dark
    });
  } else {
    StatusBar.setStyle({
      style: StatusBarStyle.Dark
    });
    StatusBar.setBackgroundColor({
      color: '#1E2E51'
    });
  }
  StatusBar.setOverlaysWebView({
    overlay: false
  });

  await Storage.migrate();
  let accessToken = (await Storage.get({key: 'access_token'})).value || localStorage.getItem('access_token');
  let expires = (await Storage.get({key: 'expires_in'})).value || localStorage.getItem('expires_in');
  let currentGroup = (await Storage.get({key: 'current_group'})).value || localStorage.getItem('current_group');

  if (accessToken && expires) {
    global.accessToken = accessToken;
    global.expires = expires;
    window.accessToken = accessToken;
    window.expires = expires;
  }

  if (currentGroup && currentGroup) {
    global.currentGroup = currentGroup;
    window.currentGroup = currentGroup;
  }

  require('./plugins/pouch');

  Vue.use(PortalVue);

  const store = require('./store').default;

  new Vue({
    router,
    store,
    vuetify: vuetify(i18n),
    i18n,
    render: h => h(App)
  }).$mount('#app');
});
